import React, {useEffect, useState } from 'react'
import { UserAuth } from "./context/AuthContext";
import { useNavigate } from "react-router-dom";
import { db } from "./firebase/config";
import { getDocs, collection, query, where } from 'firebase/firestore';
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import logo from "./logo-no-background.png"
import Select from "react-select"
export default function UserActivity() {
    let {  logout } = UserAuth();
     const [isLoading, setLoading] = useState(false);
     let [scoresData, setScoresData] = useState();
     let [allUsers, setAllUsers] = useState([]);
     let [selectedUser, setSelectedUser] = useState();

     let navigate = useNavigate();
     const optionList = [];

      useEffect(() => {
        const usersRef = collection(db, 'users');
        getDocs(usersRef).then((docSnap)=> { 
           docSnap.docs.map((d)=> {
            optionList.push({value: d.id , label: d.data().email})
           });
           setAllUsers(optionList)
        }).catch((e) => console.log(e.message)).finally(() => setLoading(false));
        },[]);

     let handleLogout = () => {
        logout();
        navigate("/");
      };

      const handleExport = () => {
        const userActivityRef = collection(db,`users/${selectedUser.value}/userActivity/`);
        getDocs(userActivityRef).then(querySnapshot => {
            let data = querySnapshot.docs.map(doc => doc.data());
            let refinedData = data.map(obj => ({Question:obj.whatQuestion, whatAnswered:obj.whatAnswered, correctAnswer:obj.correctAnswer, marked:obj.marked, whatAnsweredIndex:obj.whatAnsweredIndex, correctAnswerIndex:obj.correctAnswerIndex, date:obj.activityDate.toDate()}));
            setScoresData(data);
            console.log(refinedData)
            const fileType ="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
            const fileExtension = ".xlsx";
            const ws = XLSX.utils.json_to_sheet(refinedData);
            const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
            const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
            const excelldata = new Blob([excelBuffer], { type: fileType });
            FileSaver.saveAs(excelldata, selectedUser.label + fileExtension);
        })
        .catch(error => {
            console.error(error);
        });
      }

      function userChangeHandler(data) {
        setSelectedUser(data);
      }
  return (
    <div className="wrapper position-relative">
        <div className="header">
            <a className="logo" href={void(0)}>
              Adaptive Chinese Placement Test
            </a>
          <div className="right-content">
            <a href="#" onClick={() => navigate("/Admin")}>Export-Results</a>
            <a href="#" onClick={() => navigate("/userActivity")}>User-Activity</a>
            <a href="#" onClick={() => handleLogout()}>Logout</a>
          </div>
        </div>
          <div className="container">
              <div className="multisteps_form position-relative overflow-hidden" id="wizard">
                <div className="row">
                    <div className="col-md-12">
                      <div className="form_header_content text-center pt-4">
                          <h2>Export User Activity to Excell</h2>
                          <div className="auth-form">
                          <Select 
                            options={allUsers}
                            placeholder="Select User"
                            value={selectedUser}
                            onChange={userChangeHandler}
                            />
                            <button className="theme-btn" onClick={() => handleExport()}>
                          Export To Excell
                        </button>
                        </div>
                      </div>
                      </div>
                    </div>
                </div>
          </div>
        </div>
  )
}
